import { render, staticRenderFns } from "./SupplyPointOrdersComponent.vue?vue&type=template&id=3aa8eba4"
import script from "./SupplyPointOrdersComponent.vue?vue&type=script&lang=js"
export * from "./SupplyPointOrdersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports